import { DEFAULT_GROUP_TREASURY } from "./types";
const USER_PREFS_KEY = "mc_user_ui_preferences";
const GROUP_SETTINGS_KEY = "mc_group_module_settings";
const readJson = (key, fallback) => {
    try {
        const raw = localStorage.getItem(key);
        if (!raw)
            return fallback;
        return JSON.parse(raw);
    }
    catch {
        return fallback;
    }
};
const writeJson = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
};
const normalizeEmail = (email) => String(email || "").trim().toLowerCase() || "anon";
export const loadUserPreferences = (email) => {
    const bucket = readJson(USER_PREFS_KEY, {});
    return bucket[normalizeEmail(email)] ?? null;
};
export const saveUserPreferences = (email, prefs) => {
    const bucket = readJson(USER_PREFS_KEY, {});
    bucket[normalizeEmail(email)] = prefs;
    writeJson(USER_PREFS_KEY, bucket);
};
export const emptyUserPreferences = () => ({
    groups: {},
});
export const loadGroupSettings = (groupKey) => {
    if (!groupKey) {
        return {
            groupKey: "",
            modules: {},
            treasury: { ...DEFAULT_GROUP_TREASURY },
        };
    }
    const bucket = readJson(GROUP_SETTINGS_KEY, {});
    const stored = bucket[groupKey];
    if (!stored) {
        return {
            groupKey,
            modules: {},
            treasury: { ...DEFAULT_GROUP_TREASURY },
        };
    }
    return {
        groupKey,
        modules: stored.modules ?? {},
        treasury: {
            enabled: stored.treasury?.enabled ?? true,
            bankStatements: stored.treasury?.bankStatements ?? true,
        },
    };
};
export const saveGroupSettings = (settings) => {
    if (!settings.groupKey)
        return;
    const bucket = readJson(GROUP_SETTINGS_KEY, {});
    bucket[settings.groupKey] = settings;
    writeJson(GROUP_SETTINGS_KEY, bucket);
};
